import { services } from '@ambita/ambita-components-core';

services.i18n.registerTranslations('landRegistry', {
  nb: {
    loadingLookup: 'Laster grunnboksoppslag..',
    tooManyOwnershipsError: `Denne eiendommen har for mange tilknyttede eierskap.
    Dette gjør at vi desverre ikke klarer å produsere denne utskriften.
    Kontakt kundesenteret hvis du har ytterligere spørsmål`
  },
  'en-us': {
    loadingLookup: 'Loading land registry lookup..',
    tooManyOwnershipsError: `This property has too many related ownerships.
    This makes us unable to produce this report.
    Please contact customer support if you have any further questions.`
  }
});
